/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * request body of POST prtimes_media_lists/:media_list_id. メディアリスト名や送信者名どちらでも更新できるようにしている。いずれか一つのプロパティは必須
 * @export
 * @interface UpdateMediaListRequest
 */
export interface UpdateMediaListRequest {
    /**
     * メディアリスト名
     * @type {string}
     * @memberof UpdateMediaListRequest
     */
    mediaListName: string;
    /**
     * プレスリリース配信元のメール送信者名
     * @type {string}
     * @memberof UpdateMediaListRequest
     */
    senderName: string;
}

export function UpdateMediaListRequestFromJSON(json: any): UpdateMediaListRequest {
    return UpdateMediaListRequestFromJSONTyped(json, false);
}

export function UpdateMediaListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMediaListRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaListName': json['media_list_name'],
        'senderName': json['sender_name'],
    };
}

export function UpdateMediaListRequestToJSON(value?: UpdateMediaListRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_list_name': value.mediaListName,
        'sender_name': value.senderName,
    };
}

